import { render, staticRenderFns } from "./ladderPrice.vue?vue&type=template&id=3952d8b2&scoped=true"
import script from "./ladderPrice.vue?vue&type=script&lang=js"
export * from "./ladderPrice.vue?vue&type=script&lang=js"
import style0 from "./ladderPrice.vue?vue&type=style&index=0&id=3952d8b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3952d8b2",
  null
  
)

export default component.exports